import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getContactGlobalFieldsForEntity } from './template-contact';
import { getSubscriptionCategoryFieldsForEntity } from '@tools/config/template-subscription-category';
import { templateOrder, templateOrderItem } from '@tools/config/template-order-and-order-items';
import { getUnpaidInvoiceFieldsForEntity } from '@tools/config/template-invoice';

export const templateSubscription: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.subscriptions.code.label',
      contentValue: '{{ subscription.code }}',
      description: 'templates.subscriptions.code.description',
    },
    {
      label: 'templates.subscriptions.status.label',
      contentValue: '{{ subscription.status }}',
      description: 'templates.subscriptions.status.description',
    },
    {
      label: 'templates.subscriptions.start_date.label',
      contentValue: '{{ subscription.start_date | date("d/m/Y") }}',
      description: 'templates.subscriptions.start_date.description',
    },
    {
      label: 'templates.subscriptions.end_date.label',
      contentValue: '{{ subscription.end_date | date("d/m/Y") }}',
      description: 'templates.subscriptions.end_date.description',
    },
    {
      label: 'templates.subscriptions.total_credits.label',
      contentValue: '{{ subscription.total_credits }}',
      description: 'templates.subscriptions.total_credits.description',
    },
    {
      label: 'templates.subscriptions.remaining_credits.label',
      contentValue: '{{ subscription.remaining_credits }}',
      description: 'templates.subscriptions.remaining_credits.description',
    },
    {
      label: 'templates.subscriptions.credit_unit_price.label',
      contentValue: '{{ subscription.credit_unit_price }}',
      description: 'templates.subscriptions.credit_unit_price.description',
    },
    // {
    //   label: 'templates.subscriptions.timer.label',
    //   contentValue: '{{ subscription.timer }}',
    //   description: 'templates.subscriptions.timer.description',
    // },
    {
      label: 'templates.subscriptions.cancel_reason.label',
      contentValue: '{{ subscription.cancel_reason }}',
      description: 'templates.subscriptions.cancel_reason.description',
    },
    {
      label: 'templates.subscriptions.cancel_reason_description.label',
      contentValue: '{{ subscription.cancel_reason_description }}',
      description: 'templates.subscriptions.cancel_reason_description.description',
    },
    {
      label: 'templates.subscriptions.comment.label',
      contentValue: '{{ subscription.comment }}',
      description: 'templates.subscriptions.comment.description',
    },
    {
      label: 'templates.subscriptions.next_renewal_date.label',
      contentValue: '{{ subscription.next_renewal_date | date("d/m/Y") }}',
      description: 'templates.subscriptions.next_renewal_date.description',
    },
    {
      label: 'templates.subscriptions.price.label',
      contentValue:
        "{{ subscription.subscription_price | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
      description: 'templates.subscriptions.price.description',
    },
    {
      label: 'templates.subscriptions.paid_amount.label',
      contentValue:
        "{{ subscription.paid_amount | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
      description: 'templates.subscriptions.paid_amount.description',
    },
    {
      label: 'templates.subscriptions.last_payment_date.label',
      contentValue: '{{ subscription.last_payment_date | date("d/m/Y") }}',
      description: 'templates.subscriptions.last_payment_date.description',
    },
    {
      label: 'templates.subscriptions.all_disciplines_names_separated_by_coma.label',
      contentValue: '{{ subscription.all_disciplines_names_separated_by_coma }}',
      description: 'templates.subscriptions.all_disciplines_names_separated_by_coma.description',
    },
  ],
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.subscriptions.contact.label',
      description: 'templates.subscriptions.contact.description',
      fields: getContactGlobalFieldsForEntity('subscription.'),
    },
    {
      relationName: 'subscriptionCategory',
      relationType: 'simple',
      label: 'templates.subscriptions.subscription_category.label',
      description: 'templates.subscriptions.subscription_category.description',
      fields: getSubscriptionCategoryFieldsForEntity('subscription.'),
    },
    {
      relationName: 'templateHelper',
      relationType: 'simple',
      label: 'templates.products.pending_invoice.label',
      description: 'templates.products.pending_invoice.description',
      fields: getUnpaidInvoiceFieldsForEntity('subscription'),
    },
  ],
  relatedInLoop: [
    {
      relationName: 'orders',
      relationType: 'inLoop',
      label: 'templates.subscriptions.orders.label',
      description: 'templates.subscriptions.orders.description',
      blockStartValue: '{% for order in subscription.orders %}',
      contentValue: '{# Add some order fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateOrder.fields,
    },
    {
      relationName: 'orderItems',
      relationType: 'inLoop',
      label: 'templates.subscriptions.order_items.label',
      description: 'templates.subscriptions.order_items.description',
      blockStartValue:
        '{% for order in subscription.orders %}\n{% for orderItem in order.orderItems %}',
      contentValue: '{# Add some orderItem fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateOrderItem.fields,
    },
  ],
};
